import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["extensionName", "isFolder", "isLink"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import * as Components from '../components';
import { getIconTypeByExtension } from './fileTypeIcons';
import { jsx as _jsx } from "react/jsx-runtime";
var iconMap = {
  illustrator: Components.Illustrator,
  air: Components.Air,
  word: Components.Docx,
  encapsulatedPostScript: Components.Eps,
  flash: Components.Flash,
  indesign: Components.Indesign,
  audio: Components.Audio,
  noteworthyComposer: Components.Nwc,
  navisworks: Components.Nwf,
  pdf: Components.Pdf,
  powerpoint: Components.Pptx,
  onetoc: Components.Onetoc,
  csv: Components.Csv,
  dotx: Components.Dotx,
  mpt: Components.Mpt,
  potx: Components.Potx,
  ppsx: Components.Ppsx,
  vssx: Components.Vssx,
  vstx: Components.Vstx,
  xltx: Components.Xltx,
  photoshop: Components.Photoshop,
  quickbooksBackup: Components.QuickbooksBasic,
  quickbooksWindows: Components.QuickbooksWhite,
  rivet: Components.Rvt,
  video: Components.Videos,
  excel: Components.Xlsx,
  zip: Components.ZipFile,
  code: Components.Code,
  image: Components.Images,
  text: Components.Text,
  cad: Components.Dwg,
  keynote: Components.Keynote,
  diskCatalogMaker: Components.Dcm,
  access: Components.Mdb,
  project: Components.Mpp,
  numbers: Components.Numbers,
  pages: Components.Pages,
  publisher: Components.Pub,
  visio: Components.Vsd,
  sketch: Components.Sketch,
  onenote: Components.One,
  email: Components.Email,
  xsn: Components.Xsn,
  vsdx: Components.Vsdx,
  accdb: Components.Accdb
};
var shortcutIconMap = {
  illustrator: Components.IllustratorShortcut,
  air: Components.AirShortcut,
  word: Components.DocxShortcut,
  encapsulatedPostScript: Components.EpsShortcut,
  flash: Components.FlashShortcut,
  indesign: Components.IndesignShortcut,
  audio: Components.AudioShortcut,
  noteworthyComposer: Components.NwcShortcut,
  navisworks: Components.NwfShortcut,
  pdf: Components.PdfShortcut,
  powerpoint: Components.PptxShortcut,
  photoshop: Components.PhotoshopShortcut,
  quickbooksBackup: Components.QuickbooksBasicShortcut,
  quickbooksWindows: Components.QuickbooksWhiteShortcut,
  rivet: Components.RvtShortcut,
  video: Components.VideosShortcut,
  excel: Components.XlsxShortcut,
  zip: Components.ZipFileShortcut,
  code: Components.CodeShortcut,
  image: Components.ImagesShortcut,
  text: Components.TextShortcut,
  cad: Components.DwgShortcut,
  keynote: Components.KeynoteShortcut,
  diskCatalogMaker: Components.DcmShortcut,
  access: Components.MdbShortcut,
  project: Components.MppShortcut,
  numbers: Components.NumbersShortcut,
  pages: Components.PagesShortcut,
  publisher: Components.PubShortcut,
  visio: Components.VsdShortcut,
  sketch: Components.SketchShortcut,
  onenote: Components.OneShortcut,
  email: Components.EmailShortcut,
  onetoc: Components.OnetocShortcut,
  csv: Components.CsvShortcut,
  dotx: Components.DotxShortcut,
  mpt: Components.MptShortcut,
  ppsx: Components.PpsxShortcut,
  potx: Components.PotxShortcut,
  vssx: Components.VssxShortcut,
  vstx: Components.VstxShortcut,
  xltx: Components.XltxShortcut,
  xsn: Components.XsnShortcut,
  vsdx: Components.VsdxShortcut,
  accdb: Components.AccdbShortcut
};
function getIconFromMap(iconType, isLink) {
  return isLink ? shortcutIconMap[iconType] : iconMap[iconType];
}
function getDefaultComponent(isLink) {
  return isLink ? Components.UnknownShortcut : Components.Unknown;
}
function getIconComponent(iconType, isLink) {
  if (iconType) {
    return getIconFromMap(iconType, isLink) || getDefaultComponent(isLink);
  }
  return getDefaultComponent(isLink);
}
export function FileIcon(props) {
  var extensionName = props.extensionName,
    isFolder = props.isFolder,
    isLink = props.isLink,
    iconProps = _objectWithoutProperties(props, _excluded);
  var IconComponent;
  if (isFolder) {
    IconComponent = isLink ? Components.FolderIconShortcut : Components.FolderIcon;
  } else {
    var iconType = extensionName ? getIconTypeByExtension(extensionName) : null;
    IconComponent = getIconComponent(iconType, isLink !== null && isLink !== void 0 ? isLink : false);
  }
  return /*#__PURE__*/_jsx(IconComponent, _objectSpread({}, iconProps));
}